/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";
import Notifications from "views/Notifications.js";
import Icons from "views/Icons.js";
import Typography from "views/Typography.js";
import TableList from "views/Tables.js";
import Maps from "views/Map.js";
import UserPage from "views/SleepStatistics.js";
import UpgradeToPro from "views/Upgrade.js";

var routes = [
  {
    path: "/",
    name: "Dashboard",
    icon: "fas fa-chart-pie",
    component: Dashboard,
    layout: "/dashboard",
  }, 
  /*
  {
    path: "/",
    name: "Icons",
    icon: "nc-icon nc-diamond",
    component: Icons,
    layout: "/icons",
  },
   
  {
    path: "/",
    name: "Maps",
    icon: "nc-icon nc-pin-3",
    component: Maps,
    layout: "/maps",
  },
  {
    path: "/",
    name: "Notifications",
    icon: "nc-icon nc-bell-55",
    component: Notifications,
    layout: "/notifications",
  },
  */
 /*
  {
    path: "/",
    name: "Sleep Statistics",
    icon: "nc-icon nc-single-02",
    component: UserPage,
    layout: "/user-page",
  },
  */
  /*
  {
    path: "/",
    name: "Table List",
    icon: "nc-icon nc-tile-56",
    component: TableList,
    layout: "/tables",
  },
  {
    path: "/",
    name: "Typography",
    icon: "nc-icon nc-caps-small",
    component: Typography,
    layout: "/typography",
  },
  */
];

export default routes;
